import {BehaviorSubject} from 'rxjs';

const websocketSubscriber = new BehaviorSubject(null);

const websocketMessage = {
    send: function (msg) {
        websocketSubscriber.next(msg);
    }
}

export {
    websocketSubscriber,
    websocketMessage
}